/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SummaryChannelResponse
 */
export interface SummaryChannelResponse {
    /**
     * 
     * @type {string}
     * @memberof SummaryChannelResponse
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof SummaryChannelResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof SummaryChannelResponse
     */
    count?: number;
}

/**
 * Check if a given object implements the SummaryChannelResponse interface.
 */
export function instanceOfSummaryChannelResponse(value: object): value is SummaryChannelResponse {
    return true;
}

export function SummaryChannelResponseFromJSON(json: any): SummaryChannelResponse {
    return SummaryChannelResponseFromJSONTyped(json, false);
}

export function SummaryChannelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SummaryChannelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'total': json['total'] == null ? undefined : json['total'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function SummaryChannelResponseToJSON(json: any): SummaryChannelResponse {
    return SummaryChannelResponseToJSONTyped(json, false);
}

export function SummaryChannelResponseToJSONTyped(value?: SummaryChannelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'total': value['total'],
        'count': value['count'],
    };
}

